import { Typography, Button, Box, CircularProgress } from '@mui/material';
import { AxiosResponse } from 'axios';
import { SnackbarActionTypes, useSnackbarDispatch } from 'contexts/snackbar/SnackbarContext';
import { usePost } from 'hooks/use-post';

import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { runSimpleCalibration } from 'views/bluviu-nutrition/features/calibrations/api/simple-calibration';
import { useCalibrationState } from '../../../context/calibration-context';
import { CalibrationsParams } from '../../../types/calibrations-params.type';

const PAGE_NAME_ID = `bluViuNutrition.calibrations.editCalibration.runCalibration`;

const RunSimpleCalibration: React.FC<{}> = ({}) => {
  const params = useParams<CalibrationsParams>();
  const queryClient = useQueryClient();
  const snackbarDispatch = useSnackbarDispatch();

  const {
    simpleCalibrationStatusQuery: { refetch: refetchCalibrationStatus, data: calibrationStatus },
  } = useCalibrationState();

  const calibrate = usePost<AxiosResponse, null>(
    () => runSimpleCalibration(params.globalSiteId, params.calibrationId),
    (success) => {
      snackbarDispatch({
        type: SnackbarActionTypes.SUCCESS_SNACKBAR,
        payload: { msg: 'Simple Calibration started!' },
      });
      [['getCalibrations'], ['getSimpleCalibration', params.globalSiteId, params.calibrationId]].forEach((queryKey) => {
        queryClient.invalidateQueries({
          queryKey: queryKey,
        });
      });

      refetchCalibrationStatus();
    },
    (error) => {
      snackbarDispatch({
        type: SnackbarActionTypes.ERROR_SNACKBAR,
        payload: { msg: 'Error attempting to calibrate', error: error },
      });
    }
  );

  const handleRunCalibration = () => {
    calibrate.mutate(null);
  };

  return (
    <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'} gap={2}>
      <Typography>
        <FormattedMessage id={`${PAGE_NAME_ID}.information`} />
      </Typography>
      <Button
        onClick={() => handleRunCalibration()}
        disabled={calibrate.isPending || calibrationStatus?.calibrationIsRunning}
        startIcon={
          calibrate.isPending || calibrationStatus?.calibrationIsRunning ? <CircularProgress color="inherit" size={18} /> : null
        }>
        <FormattedMessage id={`${PAGE_NAME_ID}.button`} />
      </Button>
    </Box>
  );
};

export default React.memo(RunSimpleCalibration);
